module.exports = {
  "__version": "9.6.0"
}
